/* eslint-disable no-case-declarations */
export default (
  state = {
    status: 'loading',
    attributes: {},
    categories: []
  },
  action
) => {
  switch (action.type) {
    case 'CreateRestaurant':
      //console.log('getting ', action.payload);
      //console.log(action.payload);
      return {
        ...state,
        attributes: { ...action.payload },
        status: 'created'
      };

    case 'addCategory':
      //console.log('getting ', action.payload);
      //console.log(action.payload);
      const upcategories = state.categories.concat([action.payload]);
      return {
        // keep the old state
        ...state,

        categories: upcategories,
        status: 'category created'
      };

    case 'UpdateCategory':
      //console.log('getting ', action.payload);

      //console.log(action.payload);
      let setcategories = state.categories.map(cat => {
        if (cat.id === action.payload.id) return (cat = action.payload);
        else return cat;
      });

      return {
        // keep the old state
        ...state,
        categories: setcategories,
        // allRestaurants,
        status: 'category updated'
      };

    case 'deleteCategory':
      //console.log("deleting' ", action.payload);
      //console.log(state);
      //console.log(action.payload);
      // let categories = state.categories.filter(
      //   cat => cat.id !== action.payload
      // );

      // categories = categories.map((cat, index) => {
      //   cat.sno = index;
      //   return cat;
      // });

      return {
        // keep the old state
        ...state,
        categories: action.payload,
        status: 'category deleted'
      };

    case 'listCategories':
      // //console.log("getting################################# ", action.payload);
      //console.log(action.payload);
      return {
        ...state,
        // availableRestaurants: action.payload.jobs,
        status: 'category loaded',
        categories: action.payload
      };

    case 'sortCategories':
      //console.log('sorted ', action.payload);
      //console.log(state);
      //console.log(action.payload);
      // let categories =

      return {
        // keep the old state
        ...state,
        categories: action.payload,
        status: 'sorted'
      };

    case 'addItem':
      //console.log('getting ', action.payload);
      // //console.log(action.payload);
      const item = action.payload;
      const newCategories = state.categories.map(cat=>{
        if(cat.id === item.catid){
          if (!cat.items) 
            cat.items = [];
          cat.items.push(item)
        }
        return cat;
      })
  
      return {
        // keep the old state
        ...state,

        categories: newCategories,
        status: 'Item added'
      };

    case 'listItems':
      //console.log('getting ', action.payload);

      //console.log(action.payload);
      let catwithitems = state.categories.map(cat => {
        if (cat.id === action.payload.catid) {
          cat.items = action.payload.items;
        }
        return cat;
      });

      return {
        // keep the old state
        ...state,
        categories: catwithitems,
        // allRestaurants,
        status: 'itemsLoaded'
      };

    case 'getItemByID':
      //console.log('getting full item detail ', action.payload);
      const { catid, itemid, options, variations } = action.payload;
      //console.log(action.payload);
      let catitemsdetail = state.categories.map(cat => {
        if (cat.id === catid) {
          const items = cat.items.map(item => {
            if (item.id === itemid) item = { ...item, options, variations };
            return item;
          });
          cat.items = items;
        }

        return cat;
      });

      return {
        // keep the old state
        ...state,
        categories: catitemsdetail,
        // allRestaurants,
        status: 'itemsDetailLoaded'
      };

      case 'UpdateItem':
      //console.log('updating Items ................ '+ action.payload);
      // const {catid, id} = action.payload
      //console.log(action.payload);
       let upicategories = state.categories.map(cat => {
        if(action.payload.catid === cat.id){
         const upitems = cat.items.map(pitem => {    
          if(pitem.id === action.payload.id)
            pitem=action.payload
            return pitem   
        })
        cat.items = upitems
      }
         return cat;
      });
//console.log(upicategories)
      return {
        // keep the old state
        ...state,
        categories: upicategories,
        // allRestaurants,
        status: 'itemUpdated'
      };

      case 'listGenericOptions':
      // //console.log('getting ', action.payload);

      //console.log(action.payload);
      //console.log(action.payload.genOpts)

      let catwithgopt = state.categories.map(cat => {
        if (cat.id === action.payload.catid) {
          //console.log(cat.name)
          //console.log(action.payload.genOpts)
          cat.genericOptions = action.payload.genOpts;
        }
        //console.log(cat)
        return cat;
      });
//console.log(catwithgopt)
      return {
        // keep the old state
        ...state,
        categories: catwithgopt,
        // allRestaurants,
        status: 'generic options Loaded'
      };

      case 'setRestaurant':
        //console.log(action.payload);
        const { attributes, categories}= action.payload
        return {
          ...state,
          attributes,
          categories,
          status: 'Restaurant Loaded'
        };
  
    default:
      return state;
  }
};
